import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function OpeningHook() {
  return <div className="bg-brand-lightGreen py-20 px-6" data-id="element-122">
      <AnimatedSection className="max-w-4xl mx-auto" data-id="element-123">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-brand-green/10 relative" data-id="element-124">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-6xl text-brand-green/20 font-serif" data-id="element-125">
            "
          </div>
          <p className="text-xl md:text-2xl italic text-brand-gray leading-relaxed text-center font-serif" data-id="element-126">
            Son las 7:00 AM. Te estiras bajo las sábanas y, por primera vez en
            años, no sientes ese pinchazo agudo en las rodillas. Te levantas,
            vas a la cocina y abres el frasco de café con fuerza y seguridad en
            tus propias manos. Sin dolor. Sin el "ay" al levantarte del sofá.
            <br data-id="element-127" />
            <br data-id="element-128" />
            Esto no es un sueño. Es lo que sucede cuando apagas el "incendio
            invisible" que causa la inflamación en tu cuerpo usando ingredientes
            sencillos que ya están en el pasillo de tu supermercado local.
          </p>
        </div>
      </AnimatedSection>
    </div>;
}